/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@packages/api-client/client-config";
import type { ReviewFinancialTransactionsMutationRequest, ReviewFinancialTransactionsMutationResponse, ReviewFinancialTransactionsPathParams, ReviewFinancialTransactions400, ReviewFinancialTransactions401, ReviewFinancialTransactions403, ReviewFinancialTransactions404, ReviewFinancialTransactions409, ReviewFinancialTransactions500 } from "../../types/financialHubController/ReviewFinancialTransactions.ts";
import type { Client, RequestConfig, ResponseErrorConfig } from "@packages/api-client/client-config";

function getReviewFinancialTransactionsUrl(organizationId: ReviewFinancialTransactionsPathParams["organizationId"]) {
  const res = { method: 'POST', url: `/api/organizations/${organizationId}/financial/transactions/review` as const }
  return res
}

/**
 * @summary Confirm or re-categorize ledger transactions (bulk)
 * {@link /api/organizations/:organizationId/financial/transactions/review}
 */
export async function reviewFinancialTransactions(organizationId: ReviewFinancialTransactionsPathParams["organizationId"], data: ReviewFinancialTransactionsMutationRequest, config: Partial<RequestConfig<ReviewFinancialTransactionsMutationRequest>> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<ReviewFinancialTransactionsMutationResponse, ResponseErrorConfig<ReviewFinancialTransactions400 | ReviewFinancialTransactions401 | ReviewFinancialTransactions403 | ReviewFinancialTransactions404 | ReviewFinancialTransactions409 | ReviewFinancialTransactions500>, ReviewFinancialTransactionsMutationRequest>({ method : "POST", url : getReviewFinancialTransactionsUrl(organizationId).url.toString(), data : requestData, ... requestConfig })
  return res.data
}